function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ucsm-cls-1,.ucsm-cls-4{stroke:#034669;}.ucsm-cls-1,.ucsm-cls-3,.ucsm-cls-4{stroke-miterlimit:10;stroke-width:2px;}.ucsm-cls-1,.ucsm-cls-2,.ucsm-cls-3,.ucsm-cls-4{fill-rule:evenodd;}.ucsm-cls-1{fill:url(#linear-gradient);}.ucsm-cls-2{fill:url(#linear-gradient-2);}.ucsm-cls-3{stroke:#196b89;fill:url(#linear-gradient-3);}.ucsm-cls-4{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 136.36,
  y1: 23.23,
  x2: 136.36,
  y2: 123.13,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#949cb7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#798ca8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#476e8d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#235879"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#0d4b6d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#054669"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 136.36,
  y1: 123.13,
  x2: 136.36,
  y2: 222.79,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#cae6ca"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4284a6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 78.68,
  y1: 122.89,
  x2: 78.68,
  y2: 222.79,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#a5c1cc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#86afbe"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#5692a7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#337d97"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#1e708d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#166b89"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 194.04,
  y1: 122.89,
  x2: 194.04,
  y2: 222.79,
  xlinkHref: "#linear-gradient"
}));

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  className: "ucsm-cls-1",
  points: "136.36 123.13 78.68 123.13 107.52 73.18 136.36 23.23 165.2 73.18 194.04 123.13 136.36 123.13"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  className: "ucsm-cls-2",
  points: "136.36 123.13 193.9 123.13 165.13 172.96 136.36 222.79 107.59 172.96 78.83 123.13 136.36 123.13"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  className: "ucsm-cls-3",
  points: "78.68 222.79 21 222.79 49.84 172.84 78.68 122.89 107.52 172.84 136.36 222.79 78.68 222.79"
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  className: "ucsm-cls-4",
  points: "194.04 222.79 136.36 222.79 165.2 172.84 194.04 122.89 222.88 172.84 251.72 222.79 194.04 222.79"
});

var SvgUcsm = function SvgUcsm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "UCSM Icon",
    viewBox: "0 0 262 255",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUcsm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/UCSM.28e6deb1.svg";
export { ForwardRef as ReactComponent };